import React from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { FORMAT_TEXT_COMMAND } from 'lexical';

function Toolbar() {
  const [editor] = useLexicalComposerContext();

  const applyFormat = (formatType) => {
    editor.dispatchCommand(FORMAT_TEXT_COMMAND, formatType);
  };

  return (
    <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
      <button onClick={() => applyFormat('bold')}><b>B</b></button>
      <button onClick={() => applyFormat('italic')}>Italic</button>
      <button onClick={() => applyFormat('underline')}>Underline</button>
      <button onClick={() => applyFormat('strikethrough')}>Strike</button>
    </div>
  );
}

export default Toolbar;
